import { fromJS } from 'immutable';
import * as _ from 'lodash';

import { START, SUCCESS, ERROR } from '@actions/utils';
import { fetchingState } from '@constants';
import * as searchActions from '../actions/search';

const initialState = {
  trip: {
    state: null,
    data: {},
  },
  draggableHeight: null,
  currentSearch: {
    searchID: null,
    resultID: null,
    searchLegID: null,
    loadID: null,
    searchByUser: null,
    tolls: null,
    selectedRouteToll: null,
    selectedRouteDistance: null,
    coordinates: null,
  },
  fetchingToll: false,
  searches: {
    state: null,
    data: [],
  },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case searchActions.GEO_ROUTES_FETCH[START]: {
      return state.setIn(['trip', 'state'], fetchingState.FETCHING);
    }
    case searchActions.GEO_ROUTES_FETCH[ERROR]: {
      return state.setIn(['trip', 'state'], fetchingState.ERROR);
    }
    case searchActions.GEO_ROUTES_FETCH[SUCCESS]: {
      return state
        .setIn(['trip', 'state'], fetchingState.LOADED)
        .setIn(['trip', 'data'], fromJS(_.get(action, 'data.trip', {})));
    }

    case searchActions.SET_DRAGGABLE_HEIGHT: {
      return state.setIn(['draggableHeight'], action.payload);
    }

    case searchActions.SET_CURRENT_SEARCH: {
      return state
        .setIn(['currentSearch', 'searchID'], parseInt(action.payload.searchID))
        .setIn(['currentSearch', 'resultID'], null)
        .setIn(['currentSearch', 'searchLegID'], null)
        .setIn(['currentSearch', 'loadID'], null)
        .setIn(['currentSearch', 'tolls'], null);
    }

    case searchActions.SET_SELECTED_ROUTE_METADATA: {
      return state
        .setIn(['currentSearch', 'selectedRouteToll'], action.payload.toll)
        .setIn(
          ['currentSearch', 'selectedRouteDistance'],
          action.payload.distance,
        );
    }

    case searchActions.SET_CURRENT_LOAD: {
      return state
        .setIn(['currentSearch', 'resultID'], fromJS(action.payload.resultID))
        .setIn(
          ['currentSearch', 'searchLegID'],
          fromJS(action.payload.searchLegID),
        )
        .setIn(['currentSearch', 'loadID'], fromJS(action.payload.loadID))
        .setIn(
          ['currentSearch', 'coordinates'],
          fromJS(action.payload.coordinates),
        )
        .setIn(['currentSearch', 'tolls'], fromJS(action.payload.tolls));
    }

    case searchActions.SET_CURRENT_USER_FILTER: {
      return state.setIn(
        ['currentSearch', 'searchByUser'],
        fromJS(action.payload.searchByUser),
      );
    }

    case searchActions.TOLLS_FETCH_ERROR: {
      return state.setIn(['fetchingToll'], false);
    }

    case searchActions.TOLLS_FETCH_SUCCESS: {
      return state
        .setIn(
          ['currentSearch', 'tolls'],
          fromJS(_.get(action, 'payload', null)),
        )
        .setIn(
          ['currentSearch', 'selectedRouteToll'],
          fromJS(_.get(action, 'payload.optimalTotalTollCost', null)),
        )
        .setIn(['fetchingToll'], false);
    }

    case searchActions.TOLLS_FETCH: {
      return state
        .setIn(['currentSearch', 'selectedRouteToll'], null)
        .setIn(['currentSearch', 'selectedRouteDistance'], null)
        .setIn(['fetchingToll'], true);
    }

    default: {
      return state;
    }
  }
};
